// src/components/document-sets/SetListItem.js
// Shared component for both DocumentSetSelector and BulkDocumentSetSelector

import React from 'react';
import DocumentSetPill from './DocumentSetPill';
import SelectionCheckbox from '../pdf-table/SelectionCheckbox';

/**
 * Set list item with checkbox selection
 * Shared between DocumentSetSelector and BulkDocumentSetSelector for consistent styling
 *
 * @param {Object} set - The document set object
 * @param {boolean} isSelected - Whether the set is currently selected
 * @param {Function} onToggle - Called when checkbox is clicked
 * @param {boolean} isArchived - Whether the set is archived
 * @param {string} mode - 'add' or 'remove' (affects checkbox icon)
 */
const SetListItem = ({
  set,
  isSelected,
  onToggle,
  isArchived,
  mode = 'check', // 'check', 'add', or 'remove'
  darkMode = false,
}) => {
  // Determine checkbox variant
  const checkboxVariant = mode === 'x' ? 'x' : 'check';

  return (
    <div
      onClick={(e) => {
        // Only handle click if it's not from the checkbox
        if (e.target.closest('[role="checkbox"]')) return;
        if (!isArchived) onToggle();
      }}
      className={`
        w-full flex items-center gap-2 px-2 py-1 rounded
        ${isArchived ? 'cursor-not-allowed' : `cursor-pointer ${darkMode ? 'hover:bg-app-gray-700' : 'hover:bg-app-gray-200'}`}
      `}
    >
      {/* Checkbox on the left - uses locked state for archived sets */}
      <SelectionCheckbox
        checked={isSelected}
        onChange={() => {
          if (!isArchived) onToggle();
        }}
        disabled={isArchived}
        variant={checkboxVariant}
        locked={isArchived}
        darkMode={darkMode}
      />

      {/* Pill - apply opacity only to archived pills */}
      <div className={`flex-1 flex items-center justify-between min-w-0 ${isArchived ? 'opacity-60' : ''}`}>
        <DocumentSetPill
          documentSet={set}
          onRemove={() => {}}
          showRemove={false}
          isDraggable={false}
          isReadOnly={true}
          isArchived={isArchived}
        />
      </div>
    </div>
  );
};

export default SetListItem;